import { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CalculatorTable } from "./";
import Alert from "react-s-alert-v3";
import _ from "lodash";
import { ui_helpers } from "../helpers";
import { api, storage } from "../utils";
import { default as useUserStore } from "../hooks/useUserStore";

const CalculatorModal = ({ isOpen, setIsOpen }) => {
  const defaultTaxRate = parseFloat(storage.getItem('lastTaxRate') || "7.0");
  const [unitPrice, setUnitPrice] = useState(2900);
  const [taxRate, setTaxRate] = useState(defaultTaxRate);
  const [atLeast14Wide, setAtLeast14Wide] = useState(false);
  const [atLeast16Wide, setAtLeast16Wide] = useState(false);
  const [productType, setProductType] = useState(null);
  const [includeLDW, setIncludeLDW] = useState(true);
  const [showTotalFinancingFees, setShowTotalFinancingFees] = useState(true);
  const [customDownPayment, setCustomDownPayment] = useState(0);
  const [promotionCode, setPromotionCode] = useState('');
  const [resultsDisplayed, setResultsDisplayed] = useState(false);
  const [regions, setRegions] = useState([]);
  const [companyName, setCompanyName] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [region, setRegion] = useState(null);
  const currentUser = useUserStore(x => x.currentUser);

  useEffect(() => {
    if (currentUser && regions.length === 0 && (
      ui_helpers.isSystemAdministrator(currentUser)
        || ui_helpers.companyCount(currentUser) > 1 
        || currentUser.inferredRTOCompanyRelationCount > 1
        || ui_helpers.manufacturerCompanyCount(currentUser) > 0)
    ) {
      api.fetch("reference/RelatedCompanyRegionList").then(r => {
        if (!r.data.success) return;
        setRegions(ui_helpers.idNameToValueLabel(r.data.data));
      })
      .catch(api.catchHandler);
    }
    return () => null;
  }, [])

  function getPayload() {
    return {
      TaxRateString: taxRate,
      ProductTypeId: productType.value,
      UnitPrice: unitPrice,
      IncludeDLW: includeLDW,
      PromoCode: promotionCode,
      IdentifyTotalFinancingFees: showTotalFinancingFees,
      InitialPayment: customDownPayment,
      IsAtLeast14FeetWide: atLeast14Wide,
      IsAtLeast16FeetWide: atLeast16Wide,
      RegionId: region ? region.value : null,
      ManufacturerId: manufacturer ? manufacturer.value : null,
    };
  }

  function onPrint() {
    const pdfWindow = window.open();
    api.downloadAndOpenFile('contract/PrintPaymentCalculator', getPayload(), pdfWindow, (e) => {
      pdfWindow.close();
      console.error(e);
      Alert.error("There was an error downloading the document");
    });
  }

  return (
    <Modal size="xl" isOpen={isOpen}>
      <ModalHeader>Payment Calculator{companyName ? ` ${companyName}` : null}</ModalHeader>
      <ModalBody>
        <CalculatorTable
          showInputs={true}
          termsSelectable={false}
          unitPrice={unitPrice}
          taxRate={taxRate}
          atLeast14Wide={atLeast14Wide}
          atLeast16Wide={atLeast16Wide}
          includeLDW={includeLDW}
          customDownPayment={customDownPayment}
          regions={regions}
          onSetUnitPrice={setUnitPrice}
          onSetProductType={setProductType}
          onSetTaxRate={setTaxRate}
          onSetAtLeast14Wide={setAtLeast14Wide}
          onSetAtLeast16Wide={setAtLeast16Wide}
          onSetShowTotalFinancingFees={setShowTotalFinancingFees}
          onSetIncludeLDW={setIncludeLDW}
          onSetCustomDownPayment={setCustomDownPayment}
          onSetPromotionCode={setPromotionCode}
          onResultsDisplayed={setResultsDisplayed}
          onSetCompanyName={setCompanyName}
          onSetManufacturer={setManufacturer}
          onSetRegion={setRegion}
          showRTOCompanyName
        />
      </ModalBody>
      <ModalFooter>
        {resultsDisplayed ? (
          <Button color="dark" onClick={onPrint}>
            Print
          </Button>
        ) : null}
        <Button color="light" onClick={() => setIsOpen(!isOpen)}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CalculatorModal;
